import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Figcaption = styled("figcaption", {
  shouldForwardProp: (props) => props !== "disabled",
})(({ disabled }: { disabled?: boolean }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  background: disabled ? "#667085" : colors.error500,
  borderRadius: "8px",
  height: "fit-content",
  padding: "8px",
  width: "fit-content",

  cursor: disabled ? "default" : "pointer",
  position: "absolute",
  right: "15px",
  bottom: "10px",
}));

const useStyles = makeStyles(() => ({
  hide: {
    display: "none",
  },
  skeleton: {
    borderRadius: "8px",
  },
  figure: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
    position: "relative",
  },
  disabled: {
    backgroundColor: "#d5ddd0",
    color: "#667085",
  },
}));

export default useStyles;
